// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { SeedReturnLandingFilterVM } from '../../../../models/SeedReturn/SeedReturnLandingFilterVM';
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { CommonService } from '../../../../services/common/common.service';
import { SeedReturnService } from './../../../../services/seed/seed-return.service';
// Service Class
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { ReturnPeriodSecurityList } from '../../../../models/SeedReturn/ReturnPeriodSecurityList';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-seed-returns-soybean-dashboard',
  templateUrl: './seed-returns-soybean-dashboard.component.html',
  styleUrls: ['./seed-returns-soybean-dashboard.component.scss']
})
export class SeedReturnsSoybeanDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('returnRequestTable', { read: MatSort }) returnRequestSort: MatSort;
  @ViewChild('returnRequestPaginator', { read: MatPaginator }) returnRequestPaginator: MatPaginator;

  @ViewChild('returnRequestDraftTable', { read: MatSort }) returnRequestDraftSort: MatSort;
  @ViewChild('returnRequestDraftPaginator', { read: MatPaginator }) returnRequestDraftPaginator: MatPaginator;

  private subscription = new Array<Subscription>();
  private selectedTabIndex = 0;

  public headerYear: any;
  public draftRequestDataSource: MatTableDataSource<any>;
  public returnRequestDataSource: MatTableDataSource<any>;
  resultant: any = [];
  returnRequestDraftList: any = [];
  returnRequestList: any = [];
  headerCompany = MasterConstants.US_COMPANYCODE;
  dashboardFilter: DashboardFilter;
  returnRequestDraftColumns: string[] = [];
  returnRequestColumns: string[] = [];
  accountList: any;
  selectedAccount: number;
  validateEvolveData: any;
  readOnlyAccess: boolean = false;
  tabNode = false;
  userMenuAccessList: any;
  isEvolveAccountRestriction = false;
  selectedValue: string;
  filterValueList = new Array();
  searchTypeList: string[] = [];
  fromOrderDateFilter: any;
  toOrderDateFilter: any;
  productFilters: any;
  itemList: any = [];
  bannerMessage = '';
  isValidForReturn = false;
  filter: SeedReturnLandingFilterVM = new SeedReturnLandingFilterVM();
  deliverToAccountdetails: any = {};
  processingStatusList: any = ['ACCEPTED', 'APPROVED', 'ERROR', 'INVOICED', 'PENDING', 'PLANNED', 'REJECTED', 'SUBMITTED'];
  ddlAccounts: any[] = [];
  isApprovalAccess = false;
  notificationList: any = [{ 'id': 'Comments', 'value': 'Comments' }, { 'id': 'ManualProducts', 'value': 'Manual Products' }, { 'id': 'Errors', 'value': 'Errors' },];
  returnPeriodSecurity: ReturnPeriodSecurityList[];
  userID: string;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private matDialog: MatDialog,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private seedReturnService: SeedReturnService,
    private commonService: CommonService,
    private excelService: ExcelService) {
    this.dashboardFilter = new DashboardFilter();
  }

  // page initilization code
  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.seedReturnService.setSelectedProductLine(MasterConstants.PRODUCT_LINE_SOYBEAN);

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.userID = (sessionData.isEmulationSet ? sessionData.loggedUserId : sessionData.userId);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;

      if (this.headerCompany != undefined && this.isEvolveAccountRestriction == true) {
        this.subscription.push(this.commonService.getFilterDDLData().subscribe(result => {
          this.ddlAccounts = result.accounts;
        }, error => LolLoggerService.error(error)));
      }
      const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evolveAccessData) {
        this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION);
      }
    }

    this.isApprovalAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL);

    if (this.isApprovalAccess) {
      this.returnRequestDraftColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'dsmName', 'purchaseOrderNumber', 'orderCreateDate', 'totalProducts', 'totalUnits', 'status', 'contextMenu'];
      this.returnRequestColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'dsmName', 'purchaseOrderNumber', 'orderCreateDate', 'totalProducts', 'totalUnits', 'status'];
    }
    else {
      this.returnRequestDraftColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'purchaseOrderNumber', 'orderCreateDate', 'totalProducts', 'totalUnits', 'status', 'contextMenu'];
      this.returnRequestColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'purchaseOrderNumber', 'orderCreateDate', 'totalProducts', 'totalUnits', 'status'];
    }

    this.getReturnPeriodSecurity();
    this.setSearchTypeList();
    this.resetPageFilter();

    if (this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.itemList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST));
    } else {
      this.subscription.push(this.seedReturnService.getItemNumberList().subscribe((result: any[]) => {
        this.localStorageService.set(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST, JSON.stringify(result));
        this.itemList = result;
      }));
    }

    this.subscription.push(this.activatedRoute.paramMap.subscribe(params => {
      this.getBannerMessage();
    }));
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;

    this.setAccSummaryTableHeight();
  };

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // set account table height

  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.status-bar').outerHeight() - $('.TopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - (parseInt($('.legendBlock').outerHeight()) || 0) - $('.fulfill-top-sec').outerHeight() - 120;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
      $('.draftReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Get account list
  getAccountData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.seedReturnService.getAccountList().subscribe(result => {
      this.accountList = result;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  getReturnRequestList() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.seedReturnService.getReturnRequestList(this.filter).subscribe((result: any[]) => {
      this.returnRequestDraftList = result.filter(x => x.status === 'DRAFT');
      if (this.isValidForReturn) {
        this.draftRequestDataSource = new MatTableDataSource(this.returnRequestDraftList);
        this.draftRequestDataSource.paginator = this.returnRequestDraftPaginator;
        this.draftRequestDataSource.paginator.firstPage();
        this.draftRequestDataSource.sort = this.returnRequestDraftSort;
      }

      this.returnRequestList = result.filter(x => x.status != 'DRAFT');
      const resultant = [];
      this.returnRequestList.reduce(function (res, value) {
        if (!res[value.returnRequestNumber]) {
          res[value.returnRequestNumber] = { ...value }; // TO CLONE
          res[value.returnRequestNumber].total = 0;
          res[value.returnRequestNumber].StatusList = [];
          resultant.push(res[value.returnRequestNumber]);
        }
        res[value.returnRequestNumber].StatusList.push(value.requestStatus);
        return res;
      }, {});

      this.returnRequestDataSource = new MatTableDataSource(resultant);
      this.returnRequestDataSource.paginator = this.returnRequestPaginator;
      this.returnRequestDataSource.paginator.firstPage();
      this.returnRequestDataSource.sort = this.returnRequestSort;

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }
  // Create a new Cpp order(navigate to new order screen)
  createNewOrder() {
    if (!this.isValidForReturn) {
      this.toastrService.error('The period for submitting returns for Soybeans is closed.');
    } else {
      this.seedReturnService.setReturnRequestStatus(null);
      this.seedReturnService.setReturnRequestId(+0);
      this.router.navigate(['/seed-returns-soybean/return-request']);
    }
  }

  // Create a new Cpp order(navigate to new order screen)
  createZeroDumpstoReport() {
    if (!this.isValidForReturn) {
      this.toastrService.error('The period for submitting returns for Soybeans is closed.');
    } else {
      this.seedReturnService.setReturnRequestStatus(null);
      this.seedReturnService.setReturnRequestId(+0);
      this.router.navigate(['/seed-returns-soybean/zerodump-toreport']);
    }
  }

  // Get Banner Message
  getBannerMessage() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.seedReturnService.getBannerMessage('4J1').subscribe((result: any) => {
      this.bannerMessage = result.message;
      this.isValidForReturn = result.returnPeriodStatus;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // account change
  accountChange($event) {
    if ($event) {
      this.getReturnRequestList();
    }
  }

  // Event fired on clearing selected account from dropdown
  clearAccount() {
    this.getReturnRequestList();
  }

  // return sum of amount for draft orders
  getTotalDraftOrdersBalance() {
    return this.returnRequestDraftList.map(t => t.total).reduce((acc, value) => acc + value, 0);
  }
  // return sum of amount for placed orders
  getTotalPlacedOrdersBalance() {
    return this.returnRequestList.map(t => t.total).reduce((acc, value) => acc + value, 0);
  }

  getReturnPeriodSecurity() {
    this.subscription.push(this.seedReturnService.getReturnPeriodSecurity().subscribe((result: any[]) => {
      this.returnPeriodSecurity = result;
      this.seedReturnService.setReturnPeriodSecurityList(result);
      this.isValidForReturn = this.returnPeriodSecurity.length > 0 && this.returnPeriodSecurity.find(x => x.isActivateEntryPeriod || x.isActivateExceptionPeriod) != null ? true : false;
      // Load The data in both tab in Landing page
      this.getReturnRequestList();
    }));
  }

  // set the search filter list based on evolveaccountrestriction
  setSearchTypeList() {
    if (this.isEvolveAccountRestriction) {
      this.searchTypeList = ['Account', 'Product Name', 'Item Number', 'Request Date', 'Request ID', 'Status', 'Customer PO Number'];
    }
    else if (this.isApprovalAccess) {
      this.searchTypeList = ['Account Name', 'Account Number', 'Product Name', 'Item Number', 'Request Date', 'Request ID', 'Status', 'Customer PO#', 'By Notification'];
    }
    else {
      this.searchTypeList = ['Account Name', 'Account Number', 'Product Name', 'Item Number', 'Request Date', 'Request ID', 'Status', 'Customer PO#'];
    }
    this.selectedValue = this.searchTypeList[0];
  }

  // Reset Page Filter
  resetPageFilter() {
    this.productFilters = {
      'ProductLineId': MasterConstants.PRODUCT_LINE_SOYBEAN_CODE,
      'ItemNo': [],
      'ProductName': null,
      'AccountName': null,
      'TxtAccountNo': null,
      'AccountNo': [],
      'FromOrderDate': null,
      'ToOrderDate': null,
      'ReturnRequestNumber': null,
      'ProcessingStatus': null,
      'Notification': null,
      'ProductLineFilter': null,
      'CustomerPO': null,
      'BranchPlant': null,
    };

    this.filter = {
      'productLineId': MasterConstants.PRODUCT_LINE_SOYBEAN_CODE,
      'itemNo': null,
      'productName': null,
      'accountName': null,
      'accountCity': null,
      'accountState': null,
      'account': null,
      'fromOrderDate': null,
      'toOrderDate': null,
      'returnRequestNumber': null,
      'processingStatus': null,
      'notification': null,
      'productLineFilter': null,
      'customerPO': null,
      'branchPlant': null,
    };
  }

  // Clear selected filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeSelectedFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.getReturnRequestList();
      }
      this.setAccSummaryTableHeight();
    }
  }

  validateNumText(numInput) {
    const accountRegx = RegExp('^[0-9, ]+$');
    const isValidNumInput = accountRegx.test(numInput);
    if (!isValidNumInput) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }
    return numInput;
  }
  // Validate the search input text
  validateInputText() {
    if (this.productFilters.TxtAccountNo) {
      this.productFilters.TxtAccountNo = this.validateNumText(this.productFilters.TxtAccountNo);
    }
    if (this.productFilters.ReturnRequestNumber) {
      this.productFilters.ReturnRequestNumber = this.validateNumText(this.productFilters.ReturnRequestNumber);
    }
    if (this.productFilters.CustomerPONumber) {
      this.productFilters.CustomerPONumber = this.validateNumText(this.productFilters.CustomerPONumber);
    }
  }

  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    this.validateInputText();
    if (this.filterValueList) {
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        if (type == 'ItemNo') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.value + ','; });
        } else if (type == 'ProcessingStatus') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x + ','; });
        } else if (type == 'Notification') {
          selectedValues.forEach(x => {
            selectedIds = selectedIds + x.value + ',';
          });
        }
        else {
          selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
        }
      }

      switch (type) {
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;
        case 'ProcessingStatus':
          this.filter.processingStatus = selectedIds;
          break;
        case 'Notification':
          this.filter.notification = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.ProductName && this.productFilters.ProductName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.ProductName);
          this.filter.productName = this.productFilters.ProductName.trim();
        }
        // Set Item No
        if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
          var strIno = '';
          this.productFilters.ItemNo.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strIno.substr(0, strIno.length - 2));
        }
        // Set ProcessingStatus
        if (this.productFilters.ProcessingStatus && this.productFilters.ProcessingStatus.length > 0) {
          let strPs = '';
          this.productFilters.ProcessingStatus.forEach(x => {
            strPs = strPs + x + ', ';
          });
          this.filterValueList.push('Processing Status : ' + strPs.substr(0, strPs.length - 2));
        }
        // Set Notification
        if (this.productFilters.Notification && this.productFilters.Notification.length > 0) {
          var strIno = '';
          this.productFilters.Notification.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('By Notification : ' + strIno.substr(0, strIno.length - 2));
        }
        // text Account No
        if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
          this.filter.account = this.productFilters.TxtAccountNo.trim();
        }
        else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
          let strAct = '';
          this.productFilters.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });

          if (this.isEvolveAccountRestriction) {
            this.filterValueList.push('Account : ' + strAct.substr(0, strAct.length - 2));
          }
          else {
            this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
          }

          if (this.productFilters.AccountNo == -1) {
            this.filter.account = '-1';
          }
          else {
            this.filter.account = strAct;
          }
        }
        else {
          this.filter.account = null;
        }
        // Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName.trim();
        }
        else {
          this.filter.accountName = null;
        }

        // Web Order Number
        if (this.productFilters.ReturnRequestNumber && this.productFilters.ReturnRequestNumber != '') {
          this.filterValueList.push('Request ID : ' + this.productFilters.ReturnRequestNumber);
          this.filter.returnRequestNumber = this.productFilters.ReturnRequestNumber.trim();
        } else {
          this.filter.returnRequestNumber = null;
        }

        // Customer PO
        if (this.productFilters.CustomerPO && this.productFilters.CustomerPO != '') {
          this.filterValueList.push('Customer PO : ' + this.productFilters.CustomerPO);
          this.filter.customerPO = this.productFilters.CustomerPO.trim();
        } else {
          this.filter.customerPO = null;
        }

        if (this.productFilters.FromOrderDate
          && this.productFilters.FromOrderDate != null
          && this.productFilters.ToOrderDate
          && this.productFilters.ToOrderDate != null) {
          this.filterValueList.push('Request Date : (' + this.datePipe.transform(this.productFilters.FromOrderDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToOrderDate, 'MM/dd/yyyy') + ')');
          this.filter.fromOrderDate = new Date(this.productFilters.FromOrderDate).toDateString();
          this.filter.toOrderDate = new Date(this.productFilters.ToOrderDate).toDateString();
        }
      }
      this.setAccSummaryTableHeight();
    }
  }

  // To remove/clear selected chip search filter
  removeSelectedFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.ItemNo = null;
        this.filter.itemNo = null;
        break;

      case 'Product Name':
        this.productFilters.ProductName = null;
        this.filter.productName = null;
        break;
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.filter.accountName = null;
        break;

      case 'Request Number':
        this.productFilters.ReturnRequestNumber = null;
        this.filter.returnRequestNumber = null;
        break;
      case 'Customer PO':
        this.productFilters.CustomerPO = null;
        this.filter.customerPO = null;
        break;
      case 'Request Date':
        this.productFilters.FromOrderDate = null;
        this.productFilters.ToOrderDate = null;
        this.filter.fromOrderDate = null;
        this.filter.toOrderDate = null;
        this.fromOrderDateFilter = '';
        this.toOrderDateFilter = '';
        break;
      case 'By Notification':
        this.productFilters.Notification = null;
        this.filter.notification = null;
        break;
      case 'Processing Status':
        this.productFilters.ProcessingStatus = null;
        this.filter.processingStatus = null;
        break;
      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetPageFilter();
    this.validateOrderDateFilter('clearAll', '');
    this.getReturnRequestList();
    this.setAccSummaryTableHeight();
  }

  // validate the order date filter on search filters
  validateOrderDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromOrderDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToOrderDate) {
        var toDate = new Date(this.productFilters.ToOrderDate);
        this.fromOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toOrderDate') {
      toDate = new Date($event.value);
      this.fromOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromOrderDate) {
        var fromDate = new Date(this.productFilters.FromOrderDate);
        this.toOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromOrderDateFilter = '';
      this.toOrderDateFilter = '';
    }
  }

  // Navigate to selected order detail
  navigateOrderDetail(obj: any) {
    if (obj.status === 'IN EDIT') {
      if (obj.updateUser.toUpperCase() != this.userID.toUpperCase() && obj.isUpdatedUserActive) {
        this.toastrService.warning('Reserved By User : ' + obj.updateUser.toUpperCase());
        return;
      }
    }
    if (obj) {
      this.loaderService.setLoaderStatus(true);
      this.seedReturnService.setReturnRequestStatus(obj.status);
      this.seedReturnService.setReturnRequestId(+obj.returnRequestId);
      this.router.navigate(['/seed-returns-soybean/return-request', obj.returnRequestId]);
      this.loaderService.setLoaderStatus(false);
    }
  }

  // Delete draft request
  deleteOrder(order: any) {
    if (order) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: { title: 'Delete Draft Request', message: 'Do you want to delete this saved request?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.push(this.seedReturnService.deleteRequest(order.returnRequestId).subscribe(result => {
            if (result) {
              this.getReturnRequestList();
            }
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        }
      }));
    }
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  public exportReturnRequest() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.seedReturnService.getReturnRequestExportList(this.filter).subscribe((result: any[]) => {
      this.returnRequestList = result.filter(x => x.status != 'DRAFT');
      this.returnRequestDraftList = result.filter(x => x.status === 'DRAFT');
      if (this.selectedTabIndex === 0 && this.returnRequestList && this.returnRequestList.length > 0) {
        this.returnRequestList.forEach(x => {
          exportData.push({
            'RequestID': x.returnRequestNumber,
            'Customer PO': x.purchaseOrderNumber,
            'Account#': x.accountNumber,
            'Account Name': x.accountName,
            'Account Address': x.accountAddress1,
            'Account City': x.accountCity,
            'Account State': x.accountState,
            'Account Zip': x.accountZipCode,
            'Request Date': this.datePipe.transform(x.orderCreateDate, MasterConstants.DATE_MMDDYYYY),
            'Item': x.productName,
            'Product Line Description': this.seedReturnService.getProductLineTextById(x.productLine),
            'Lot Number': x.lotNumber,
            'Returned Units': x.totalUnits,
            'Status': x.status,
          });
        });
        this.excelService.exportAsExcelFile(exportData, 'Active_Soybean_Returns');
      } else if (this.selectedTabIndex === 1 && this.returnRequestDraftList && this.returnRequestDraftList.length > 0) {
        this.returnRequestDraftList.forEach(x => {
          exportData.push({
            'RequestID': x.returnRequestNumber,
            'Customer PO': x.purchaseOrderNumber,
            'Account#': x.accountNumber,
            'Account Name': x.accountName,
            'Account Address': x.accountAddress1,
            'Account City': x.accountCity,
            'Account State': x.accountState,
            'Account Zip': x.accountZipCode,
            'Request Date': this.datePipe.transform(x.orderCreateDate, MasterConstants.DATE_MMDDYYYY),
            'Item': x.productName,
            'Product Line Description': this.seedReturnService.getProductLineTextById(x.productLine),
            'Lot Number': x.lotNumber,
            'Returned Units': x.totalUnits,
            'Status': x.status,
          });
        });
        this.excelService.exportAsExcelFile(exportData, 'Draft_Soybean_Returns');
      }
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));

  }
}
